import { render, staticRenderFns } from "./ValueDetails.vue?vue&type=template&id=9c7b0ed0&scoped=true&"
import script from "./ValueDetails.vue?vue&type=script&lang=ts&"
export * from "./ValueDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7b0ed0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VBtnToggle,VDivider})
